import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-header', {
  mixins: [eventListenerMixin],

  connected() {
    const infoLink = this.querySelector('.project-info-link-item');
    this.listenTo(infoLink, 'click', this.handleInfoLinkClick.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleInfoLinkClick(event) {
    const dialog = this.querySelector('.project-info-dialog');
    if (dialog) {
      event.preventDefault();
      event.stopPropagation();
      dialog.open();
    }
  },
});
